// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1ncYg","dragIcon":"Choice_dragIcon__2IJ4m","left":"Choice_left__1eg2l","input":"Choice_input__3vasz"};